export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8673.a6d7e97b.jpg";